var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimelineEmergencyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_1082)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#FC8DC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6058 11.1535C10.831 9.35193 12.3625 8 14.178 8H21.822C23.6375 8 25.169 9.35193 25.3942 11.1535L27 24H9L10.6058 11.1535Z",
    fill: "#F02E8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 25.6C8 24.1641 9.16406 23 10.6 23H25.4C26.8359 23 28 24.1641 28 25.6V26C28 26.5523 27.5523 27 27 27H9C8.44772 27 8 26.5523 8 26V25.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4164 12.8052C19.4164 12.3605 19.0558 12 18.6111 12H17.3889C16.9442 12 16.5837 12.3605 16.5837 12.8052V14.5837L14.8052 14.5837C14.3605 14.5837 14 14.9442 14 15.3889L14 16.6111C14 17.0558 14.3605 17.4164 14.8052 17.4164H16.5837V19.1948C16.5837 19.6395 16.9442 20 17.3889 20H18.6111C19.0558 20 19.4164 19.6395 19.4164 19.1948V17.4164H21.1948C21.6395 17.4164 22 17.0558 22 16.6111V15.3889C22 14.9442 21.6395 14.5837 21.1948 14.5837H19.4164V12.8052Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_1082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineEmergencyIcon);
export default __webpack_public_path__ + "static/media/timeline-emergency-icon.6967a6e366c4db7eac10187b7f266184.svg";
export { ForwardRef as ReactComponent };